import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CheckPassportGuard } from '../../common/guards/check-passport.guard';

import { InsuranceIdByTypes } from './insurance';
import { InsuranceCreateExternalWizardComponent } from './insurance-create-external-wizard/insurance-create-external-wizard.component';
import { InsuranceDetailComponent } from './insurance-detail/insurance-detail.component';
import { InsuranceSportCreateWizardComponent } from './insurance-sport-create-wizard-wizard/insurance-sport-create-wizard.component';
import { InsuranceSuggestionsComponent } from './insurance-suggestions/insurance-suggestions.component';

const routes: Routes = [
	{
		path: '',
		component: InsuranceSuggestionsComponent,
	},
	{
		path: 'create',
		component: InsuranceCreateExternalWizardComponent,
		canActivate: [CheckPassportGuard],
	},
	{
		path: 'sport/:insuranceId/:agreementId',
		component: InsuranceDetailComponent,
		canActivate: [CheckPassportGuard],

	},
	{
		path: `create/${InsuranceIdByTypes.SPORT}`,
		component: InsuranceSportCreateWizardComponent,
		canActivate: [CheckPassportGuard],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [],
})
export class InsuranceSectionRoutingModule { }
